/* eslint-disable */
// @ts-nocheck
import * as Types from '@xing-com/crate-common-graphql-types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GetVitaArticleQueryVariables = Types.Exact<{
  slugOrID: Types.Scalars['SlugOrID']['input'];
}>;

export type GetVitaArticleQuery = {
  __typename?: 'Query';
  articlesArticle?: {
    __typename?: 'ArticlesArticle';
    id: string;
    slug: string;
    globalId: string;
    contextGlobalId: string;
    header: {
      __typename?: 'ArticleHeader';
      title: { __typename?: 'ArticleTitle'; text: string };
      summary?: { __typename?: 'ArticleSummary'; text: string } | null;
      cover?:
        | { __typename?: 'ArticleCoverImage'; url?: string | null }
        | { __typename?: 'ArticleCoverVideo' }
        | null;
    };
    blocks: Array<
      | {
          __typename: 'ArticleBodyImage';
          id?: number | null;
          uuid: string;
          caption?: {
            __typename: 'ArticleCaption';
            text?: string | null;
          } | null;
          image?: Array<{
            __typename: 'ScaledImage';
            url?: string | null;
            reference?: string | null;
          }> | null;
        }
      | { __typename?: 'ArticleEmphasis'; text: string }
      | {
          __typename?: 'ArticleH2';
          text: string;
          markups: Array<
            | { __typename: 'ArticleBoldMarkup'; end: number; start: number }
            | { __typename: 'ArticleItalicMarkup'; end: number; start: number }
            | {
                __typename: 'ArticleLinkMarkup';
                end: number;
                start: number;
                href: string;
              }
            | {
                __typename: 'ArticleMentionMarkup';
                userId: string;
                end: number;
                start: number;
                user?: {
                  __typename?: 'XingId';
                  pageName: string;
                  globalId: string;
                } | null;
              }
          >;
        }
      | {
          __typename?: 'ArticleH3';
          text: string;
          markups: Array<
            | { __typename: 'ArticleBoldMarkup'; end: number; start: number }
            | { __typename: 'ArticleItalicMarkup'; end: number; start: number }
            | {
                __typename: 'ArticleLinkMarkup';
                end: number;
                start: number;
                href: string;
              }
            | {
                __typename: 'ArticleMentionMarkup';
                userId: string;
                end: number;
                start: number;
                user?: {
                  __typename?: 'XingId';
                  pageName: string;
                  globalId: string;
                } | null;
              }
          >;
        }
      | {
          __typename?: 'ArticleH4';
          text: string;
          markups: Array<
            | { __typename: 'ArticleBoldMarkup'; end: number; start: number }
            | { __typename: 'ArticleItalicMarkup'; end: number; start: number }
            | {
                __typename: 'ArticleLinkMarkup';
                end: number;
                start: number;
                href: string;
              }
            | {
                __typename: 'ArticleMentionMarkup';
                userId: string;
                end: number;
                start: number;
                user?: {
                  __typename?: 'XingId';
                  pageName: string;
                  globalId: string;
                } | null;
              }
          >;
        }
      | {
          __typename?: 'ArticleOrderedListItem';
          text: string;
          markups: Array<
            | { __typename: 'ArticleBoldMarkup'; end: number; start: number }
            | { __typename: 'ArticleItalicMarkup'; end: number; start: number }
            | {
                __typename: 'ArticleLinkMarkup';
                end: number;
                start: number;
                href: string;
              }
            | {
                __typename: 'ArticleMentionMarkup';
                userId: string;
                end: number;
                start: number;
                user?: {
                  __typename?: 'XingId';
                  pageName: string;
                  globalId: string;
                } | null;
              }
          >;
        }
      | {
          __typename?: 'ArticleParagraph';
          text: string;
          markups: Array<
            | { __typename: 'ArticleBoldMarkup'; end: number; start: number }
            | { __typename: 'ArticleItalicMarkup'; end: number; start: number }
            | {
                __typename: 'ArticleLinkMarkup';
                end: number;
                start: number;
                href: string;
              }
            | {
                __typename: 'ArticleMentionMarkup';
                userId: string;
                end: number;
                start: number;
                user?: {
                  __typename?: 'XingId';
                  pageName: string;
                  globalId: string;
                } | null;
              }
          >;
        }
      | { __typename?: 'ArticleQuote' }
      | {
          __typename?: 'ArticleUnorderedListItem';
          text: string;
          markups: Array<
            | { __typename: 'ArticleBoldMarkup'; end: number; start: number }
            | { __typename: 'ArticleItalicMarkup'; end: number; start: number }
            | {
                __typename: 'ArticleLinkMarkup';
                end: number;
                start: number;
                href: string;
              }
            | {
                __typename: 'ArticleMentionMarkup';
                userId: string;
                end: number;
                start: number;
                user?: {
                  __typename?: 'XingId';
                  pageName: string;
                  globalId: string;
                } | null;
              }
          >;
        }
    >;
  } | null;
};

export type LebenslaufArticleBlockTopicMarkupsFragment_ArticleBoldMarkup_Fragment =
  { __typename: 'ArticleBoldMarkup'; end: number; start: number };

export type LebenslaufArticleBlockTopicMarkupsFragment_ArticleItalicMarkup_Fragment =
  { __typename: 'ArticleItalicMarkup'; end: number; start: number };

export type LebenslaufArticleBlockTopicMarkupsFragment_ArticleLinkMarkup_Fragment =
  { __typename: 'ArticleLinkMarkup'; end: number; start: number; href: string };

export type LebenslaufArticleBlockTopicMarkupsFragment_ArticleMentionMarkup_Fragment =
  {
    __typename: 'ArticleMentionMarkup';
    userId: string;
    end: number;
    start: number;
    user?: { __typename?: 'XingId'; pageName: string; globalId: string } | null;
  };

export type LebenslaufArticleBlockTopicMarkupsFragmentFragment =
  | LebenslaufArticleBlockTopicMarkupsFragment_ArticleBoldMarkup_Fragment
  | LebenslaufArticleBlockTopicMarkupsFragment_ArticleItalicMarkup_Fragment
  | LebenslaufArticleBlockTopicMarkupsFragment_ArticleLinkMarkup_Fragment
  | LebenslaufArticleBlockTopicMarkupsFragment_ArticleMentionMarkup_Fragment;

export const LebenslaufArticleBlockTopicMarkupsFragmentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'LebenslaufArticleBlockTopicMarkupsFragment',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticleMarkupInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleMentionMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'globalId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleBoldMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleItalicMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleLinkMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'href' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  LebenslaufArticleBlockTopicMarkupsFragmentFragment,
  unknown
>;
export const GetVitaArticleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetVitaArticle' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'slugOrID' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articlesArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'slugOrID' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'supportedBlockTypes' },
                value: {
                  kind: 'ListValue',
                  values: [
                    { kind: 'EnumValue', value: 'ARTICLE_BODY_IMAGE' },
                    { kind: 'EnumValue', value: 'ARTICLE_EMPHASIS' },
                    { kind: 'EnumValue', value: 'ARTICLE_H2' },
                    { kind: 'EnumValue', value: 'ARTICLE_H3' },
                    { kind: 'EnumValue', value: 'ARTICLE_H4' },
                    { kind: 'EnumValue', value: 'ARTICLE_ORDERED_LIST_ITEM' },
                    { kind: 'EnumValue', value: 'ARTICLE_PARAGRAPH' },
                    { kind: 'EnumValue', value: 'ARTICLE_UNORDERED_LIST_ITEM' },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contextGlobalId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'header' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'title' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cover' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: {
                                kind: 'NamedType',
                                name: {
                                  kind: 'Name',
                                  value: 'ArticleCoverImage',
                                },
                              },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'blocks' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleParagraph' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'LebenslaufArticleBlockTopicMarkupsFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleH2' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'LebenslaufArticleBlockTopicMarkupsFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleH3' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'LebenslaufArticleBlockTopicMarkupsFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleH4' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'LebenslaufArticleBlockTopicMarkupsFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ArticleUnorderedListItem',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'LebenslaufArticleBlockTopicMarkupsFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: {
                            kind: 'Name',
                            value: 'ArticleOrderedListItem',
                          },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'markups' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value:
                                        'LebenslaufArticleBlockTopicMarkupsFragment',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleEmphasis' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ArticleBodyImage' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caption' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'text' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'uuid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'image' },
                              arguments: [
                                {
                                  kind: 'Argument',
                                  name: { kind: 'Name', value: 'dimensions' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'width',
                                            },
                                            value: {
                                              kind: 'IntValue',
                                              value: '700',
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'height',
                                            },
                                            value: {
                                              kind: 'IntValue',
                                              value: '700',
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'reference',
                                            },
                                            value: {
                                              kind: 'StringValue',
                                              value: 'square600',
                                              block: false,
                                            },
                                          },
                                        ],
                                      },
                                      {
                                        kind: 'ObjectValue',
                                        fields: [
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'width',
                                            },
                                            value: {
                                              kind: 'IntValue',
                                              value: '900',
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'height',
                                            },
                                            value: {
                                              kind: 'IntValue',
                                              value: '900',
                                            },
                                          },
                                          {
                                            kind: 'ObjectField',
                                            name: {
                                              kind: 'Name',
                                              value: 'reference',
                                            },
                                            value: {
                                              kind: 'StringValue',
                                              value: 'square900',
                                              block: false,
                                            },
                                          },
                                        ],
                                      },
                                    ],
                                  },
                                },
                              ],
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'url' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'reference' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: '__typename' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'LebenslaufArticleBlockTopicMarkupsFragment',
      },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticleMarkupInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleMentionMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'globalId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleBoldMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleItalicMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ArticleLinkMarkup' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'end' } },
                { kind: 'Field', name: { kind: 'Name', value: 'start' } },
                { kind: 'Field', name: { kind: 'Name', value: 'href' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetVitaArticleQuery, GetVitaArticleQueryVariables>;
